import type { GameData, Shot, Spark } from "./model.ts";

export const MAX_ACTIVE_SHOTS = 96;
export const MAX_ACTIVE_SPARKS = 384;
const MAX_RETAINED_SHOTS = 96;
const MAX_RETAINED_SPARKS = 384;

type ShotSeed = Omit<Shot, "active">;
type SparkSeed = Omit<Spark, "active">;

function ensurePools(game: GameData) {
  game.shotPool ??= [];
  game.sparkPool ??= [];
  game.sparkOverwriteIndex ??= 0;
}

export function acquireShot(game: GameData, seed: ShotSeed) {
  ensurePools(game);
  if (game.shots.length >= MAX_ACTIVE_SHOTS) return null;
  const shot = game.shotPool.pop() ?? ({ ...seed, active: true } as Shot);
  Object.assign(shot, seed, { active: true });
  game.shots.push(shot);
  return shot;
}

export function acquireSpark(game: GameData, seed: SparkSeed) {
  ensurePools(game);
  if (game.sparks.length >= MAX_ACTIVE_SPARKS) {
    const index = game.sparkOverwriteIndex % game.sparks.length;
    const spark = game.sparks[index];
    Object.assign(spark, seed, { active: true });
    game.sparkOverwriteIndex = (index + 1) % game.sparks.length;
    return spark;
  }
  const spark = game.sparkPool.pop() ?? ({ ...seed, active: true } as Spark);
  Object.assign(spark, seed, { active: true });
  game.sparks.push(spark);
  return spark;
}

export function recycleInactiveShots(game: GameData) {
  ensurePools(game);
  let writeIndex = 0;
  for (const shot of game.shots) {
    if (shot.active !== false) {
      shot.active = true;
      game.shots[writeIndex++] = shot;
    } else if (game.shotPool.length < MAX_RETAINED_SHOTS) {
      game.shotPool.push(shot);
    }
  }
  game.shots.length = writeIndex;
}

export function recycleInactiveSparks(game: GameData) {
  ensurePools(game);
  let writeIndex = 0;
  for (const spark of game.sparks) {
    if (spark.active !== false) {
      spark.active = true;
      game.sparks[writeIndex++] = spark;
    } else if (game.sparkPool.length < MAX_RETAINED_SPARKS) {
      game.sparkPool.push(spark);
    }
  }
  game.sparks.length = writeIndex;
  game.sparkOverwriteIndex %= Math.max(1, game.sparks.length);
}
